import { IReduxStore }   from 'Redux/Store/IReduxStore';
import {
  FIND_FILE_REFERENCES_REQUEST,
  SEARCH_FILE_REFERENCES_REQUEST,
  CREATE_FILE_REFERENCE_REQUEST,
  UPDATE_FILE_REFERENCE_REQUEST,
  DELETE_FILE_REFERENCE_REQUEST,
}                        from 'Redux/Action';
import { ArrayContains } from 'ClientService';

export const isFileReferenceLoading = (state: IReduxStore): boolean =>
  ArrayContains(state.fileReference.openRequests, [
    FIND_FILE_REFERENCES_REQUEST,
    SEARCH_FILE_REFERENCES_REQUEST,
    UPDATE_FILE_REFERENCE_REQUEST,
    DELETE_FILE_REFERENCE_REQUEST,
    CREATE_FILE_REFERENCE_REQUEST,
  ]);
